import materialStiffnessCalculatorHtml from './materialStiffnessCalculator.html';
import './materialStiffnessCalculator.scss';

class MaterialStiffnessCalculatorController {

    constructor($scope, $window, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$window = $window;
        this.translate = translateService;
        this.rawData = {
            '1.5': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,SZ,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                200,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                300,W,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                400,W,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                500,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                700,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                900,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1200,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1500,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1800,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                2000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW`,
            '2': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,SZ,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                200,SZ,SZ,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                300,W,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                400,W,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                500,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                700,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                900,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1200,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1500,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1800,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                2000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW`,
            '3': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW
                200,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW
                300,SZ,SZ,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW
                400,SZ,SZ,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW
                500,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW
                700,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW
                900,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1200,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1500,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1800,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                2000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW`,
            '4': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW
                200,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW
                300,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW
                400,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW
                500,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW
                700,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW
                900,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW
                1000,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW
                1200,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW
                1500,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1800,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                2000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW`,
            '5': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,SZ,SZ,W,W,BW,BW,BW,BW,BW,BW,BW
                200,BS,BS,BS,BS,BS,SZ,SZ,W,W,BW,BW,BW,BW,BW,BW,BW
                300,BS,BS,BS,BS,BS,SZ,SZ,W,W,BW,BW,BW,BW,BW,BW,BW
                400,BS,BS,BS,BS,BS,SZ,SZ,W,W,BW,BW,BW,BW,BW,BW,BW
                500,BS,BS,BS,BS,BS,SZ,SZ,W,W,BW,BW,BW,BW,BW,BW,BW
                700,SZ,SZ,SZ,SZ,SZ,SZ,SZ,W,W,BW,BW,BW,BW,BW,BW,BW
                900,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W,BW,BW,BW,BW,BW,BW,BW
                1000,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW
                1200,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW,BW,BW,BW
                1500,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                1800,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW
                2000,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW,BW`,
            '6': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW
                200,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW
                300,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW
                400,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW
                500,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW
                700,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW
                900,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,BW,BW,BW,BW
                1000,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W,BW,BW,BW,BW
                1200,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W,BW,BW,BW,BW
                1500,W,W,W,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW
                1800,W,W,W,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW
                2000,W,W,W,W,W,W,W,W,W,W,W,W,BW,BW,BW,BW`,
            '8': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                200,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                300,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                400,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                500,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                700,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                900,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                1000,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                1200,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,W,W,W,W,BW
                1500,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W,W,BW
                1800,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W,W,BW
                2000,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,BW`,
            '10': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                300,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                400,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                700,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                900,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                1000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                1200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                1500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,W,W,W
                1800,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W
                2000,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,SZ,W,W,W`,
            '15': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                300,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                400,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                700,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                900,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                1000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                1200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                1500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                1800,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ
                2000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,SZ,SZ,SZ,SZ,SZ`,
            '20': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                300,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                400,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                700,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                900,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1800,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                2000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS`,
            '25': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                300,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                400,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                700,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                900,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1800,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                2000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS`,
            '30': `100,200,300,400,500,700,900,1000,1200,1500,1800,2000,2300,2500,2800,3000
                100,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                300,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                400,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                700,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                900,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1200,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1500,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                1800,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS
                2000,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS,BS`
        }
        this.data = {};
        this.sizes = ['1.5', '2', '3', '4', '5', '6', '8', '10', '15', '20', '25', '30'];
        this.title = '';
        this.description = '';

        angular.element($window).bind('resize', function(){
            $scope.$digest();
        });

        this.size = this.sizes[0];
        this.width = this.tmpWidth = 100;
        this.height = this.tmpHeight = 100;
    }

    $onInit() {
        console.log(this.translate.t('currency'));

        this.stiffnessDescription = {
            'BS': {'title': 'materialStiffnessCalculator.veryStiff.title', 'description': 'materialStiffnessCalculator.veryStiff.description'},
            'SZ': {'title': 'materialStiffnessCalculator.stiff.title', 'description' : 'materialStiffnessCalculator.stiff.description'},
            'W': {'title': 'materialStiffnessCalculator.limp.title', 'description' : 'materialStiffnessCalculator.limp.description'},
            'BW': {'title': 'materialStiffnessCalculator.veryLimp.title', 'description' : 'materialStiffnessCalculator.veryLimp.description'}
        }

        this.$scope.$watch(
            () => this.isMobile,
            (isMobile, wasMobile) => {
                if (wasMobile === isMobile) {
                    return;
                }
            },
            true
        );

        this.$scope.$watch(
            () => this.tmpWidth,
            (tmpWidth, oldTmpWidth) => {
                this.applyChanges('width');
            },
            true
        );

        this.$scope.$watch(
            () => this.tmpHeight,
            (tmpWidth, oldTmpWidth) => {
                this.applyChanges('height');
            },
            true
        )
    }

    get stiffness() {
        if (typeof (this.data[this.size]) === 'undefined') {
            let stiffness = {};
            let widths = [];
            let heights = [];
            let data = {
                'widths': widths,
                'heights': heights,
                'stiffness': stiffness,
            }

            this.data[this.size] = data;

            let rows = this.rawData[this.size].split('\n');

            rows.forEach((row, rowIndex)  => {
                let columns = row.split(',');

                if (rowIndex === 0) {
                    columns.forEach(width => {
                        widths.push(parseInt(width));
                    });
                } else {
                    columns.forEach((cell, columnIndex) => {
                        if (columnIndex === 0) {
                            heights.push(parseInt(cell));
                        } else {
                            if(!stiffness[heights[rowIndex - 1]]) {
                                stiffness[heights[rowIndex - 1]] = {};
                            }
                            stiffness[heights[rowIndex - 1]][widths[columnIndex - 1]] = cell;
                        }
                    });
                }
            });
        }

        let sizeData = this.data[this.size];

        let widthRange = sizeData.widths[0];
        let heightRange = sizeData.heights[0];

        sizeData.widths.every(width => {
            if (width >= this.width) {
                widthRange = width;
                return false;
            }
            return true;
        });

        sizeData.heights.every(height => {
            if (height >= this.height) {
                heightRange = height;
                return false;
            }
            return true;
        });

        let stiffness = sizeData.stiffness[heightRange][widthRange];

        this.title = this.translate.t(this.stiffnessDescription[stiffness].title);
        this.description = this.translate.t(this.stiffnessDescription[stiffness].description);

        return stiffness;
    }

    get maxWidth() {
        if (!this.data[this.size]) {
            return;
        }

        return this.data[this.size]['widths'][this.data[this.size]['widths'].length - 1];
    }

    get maxHeight() {
        if (!this.data[this.size]) {
            return;
        }

        return this.data[this.size]['heights'][this.data[this.size]['heights'].length - 1];
    }

    get ready() {
        console.log('ready', this.width === this.tmpWidth && this.height === this.tmpHeight);
        return this.width === this.tmpWidth && this.height === this.tmpHeight;
    }

    applyChanges(field) {
        console.log('applyChanges');
        switch(field) {
            case 'width':
                console.log('w', this.tmpWidth);
                if (!this.tmpWidth) {
                    this.tmpWidth = this.width;
                } else if(this.tmpWidth > this.maxWidth) {
                    this.width = this.tmpWidth = this.maxWidth;
                } else {
                    this.width = this.tmpWidth;
                }
                break;
            case 'height':
                if (!this.tmpHeight) {
                    this.tmpHeight = this.height;
                } else if(this.tmpHeight > this.maxHeight) {
                    this.height = this.tmpHeight = this.maxHeight;
                } else {
                    this.height = this.tmpHeight;
                }
                break;
        }
    }

    get isMobile() {
        return this.$window.innerWidth <= 720;
    }
}

let materialStiffnessCalculatorComponent = {
    bindings: {
        'value': '<',
        'net': '<',
        'hideTaxText': '<',
        'showSimpleTaxText': '<',
        'currency': '<'
    },
    template: materialStiffnessCalculatorHtml,
    controller: MaterialStiffnessCalculatorController
};

export default materialStiffnessCalculatorComponent;
